<div class="notification-component" [ngClass]="notificationClass">
  <div class="Flexbox Flexbox_rows Flexbox__align-self-start">
    <span [ngClass]="symbolClass"></span>
    <span class="header">{{getHeader()}}</span>
    <span class="content">{{getContent()}}</span>
  </div>
</div>
